import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TimelineService } from "../services/timeline.service";
import { Globals } from "../globals";
import { Observable } from 'rxjs';
import { DomSanitizer } from "@angular/platform-browser";
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-timeline-modal',
  templateUrl: './timeline-modal.component.html',
  styleUrls: ['./timeline-modal.component.css']
})
export class TimelineModalComponent implements OnInit {

  isAdd: boolean = false;
  isUpdate: boolean = false;
  hasEditPrivilage: boolean = true;
  typesArr: any = [
    { id: "OFFER", name: 'timeline.offer' },
    { id: "ANNOUNCEMENT", name: 'timeline.announcement' }
  ];
  type: string = "";
  timelineDetails: any = {};
  primaryImage: any = null;
  primaryImageFile: any = null;

  constructor(public dialogRef: MatDialogRef<TimelineModalComponent>, private globals: Globals,
    @Inject(MAT_DIALOG_DATA) public data: any, private timelineService: TimelineService, private sanitizer: DomSanitizer,) { }

  ngOnInit(): void {
    const { isAdd, timelineDetails, isUpdate } = this.data;
    this.isAdd = isAdd;
    this.isUpdate = isUpdate;
    this.timelineDetails = timelineDetails;
    this.type = this.timelineDetails?.type;
    setTimeout(() => {
      var modal = document.querySelector(".mat-dialog-container");
      if (modal) {
        modal.scrollTo({ top: 0, behavior: 'smooth' });
      }
    }, 500);
    if (this.timelineDetails?.primaryImage) {
      this.getPhoto(this.timelineDetails?.primaryImage).subscribe(result => {
        this.primaryImage = result;
      });
    }
  }

  close(refresh): void {
    this.dialogRef.close(refresh);
  }

  addTimeline() {

    let data: any = {
      type: this.type,
      descriptionAr: this.timelineDetails.descriptionAr,
      description: this.timelineDetails.description
    };

    if (this.primaryImageFile) {
      data.primaryImageFile = this.primaryImageFile;
    }

    this.timelineService.addNewTimeline(data).subscribe(result => {
      this.close(true);
    });
  }

  updateTimeline() {
    let data: any = {
      type: this.type,
      descriptionAr: this.timelineDetails.descriptionAr,
      description: this.timelineDetails.description
    };

    if (this.primaryImageFile) {
      data.primaryImageFile = this.primaryImageFile;
    }

    this.timelineService.updateTimeline(data, this.timelineDetails.id).subscribe(result => {
      this.close(true);
    });
  }

  addImage() {
    if (this.isAdd || this.isUpdate) {
      let element: HTMLElement = document.getElementById(
        "imageFileUpload"
      ) as HTMLElement;
      element.click();
    }
  }

  onImageSelected(event) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = (event: any) => {
        var img = new Image();
        img.onload = () => {
          // if (img.width != 400 || img.height != 400) {
          //   this.globals.presentErrorToast("Image should be 400w * 400h");
          //   return false;
          // }
          // else {
            let imageURL = event.target.result;
            if (imageURL) {
              let dataURI = imageURL;//this.resizeImg(img);
              let file = this.globals.dataURItoBlob(dataURI);
              this.primaryImageFile = file;
            }
            this.primaryImage = img.src;
          // }
        };
        img.src = reader.result as string;
      };
    }
  }

  resizeImg(img) {
    // We create a canvas and get its context.
    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext('2d');

    // We set the dimensions at the wanted size.
    canvas.width = 400;
    canvas.height = 400;

    // We resize the image with the canvas method drawImage();
    ctx.drawImage(img, 0, 0, 400, 400);

    return canvas.toDataURL();
  }

  getPhoto(path) {
    const ImageObservable = new Observable(observer => {
      if (path != "" && path != null) {
        this.timelineService.getImage(path).subscribe((result: any) => {
          var binary = "";
          var bytes = new Uint8Array(result);
          var len = bytes.byteLength;
          for (var i = 0; i < len; i++) {
            binary += String.fromCharCode(bytes[i]);
          }
          var newImage = window.btoa(binary);
          observer.next(
            this.sanitizer.bypassSecurityTrustUrl(
              "data:image/jpg;base64, " + newImage
            )
          );
        });
      } else {
        observer.next("");
      }
    });
    return ImageObservable;
  }

  formateDate(date) {
    var datePipe = new DatePipe("en");
    return datePipe.transform(date, 'yyyy/MM/dd hh:mm:ss a');
  }
}
